import React from "react";

const TitleHeading = ({ label }) => {
  return <h1 className="text-3xl xl:text-3xl mb-4 text-gray-900 font-bold">{label}</h1>;
};
export default TitleHeading;
